import React from 'react';

const GaussianSplatting = ({ selected3DGS }) => {
  return (
    <section id="gaussian-splatting">
      {selected3DGS ? (
        <iframe
          src={selected3DGS}
          title="3D Gaussian Splatting"
          width="100%"
          height="500px"
          style={{ border: 'none' }}
        />
      ) : (
        <p>No 3D Gaussian Splatting selected</p>
      )}
    </section>
  );
};

export default GaussianSplatting;